import React from 'react';

const Footer = () => (
  <footer className="">
    <div class="bg-white">
      <div class="max-w-screen-xl mx-auto pt-12 px-4 sm:px-6 lg:pt-12 lg:px-8">
        <div class="xl:grid xl:grid-cols-3 xl:gap-8">
          <div class="md:grid md:grid-cols-2 gap-8 xl:col-span-2">
            <div class="md:grid md:grid-cols-1 md:gap-8">
              <div>
                <h4 class="text-sm leading-5 font-semibold tracking-wider text-gray-400 uppercase">
                  Get in Touch
                </h4>
                <ul class="mt-4">
                  <li>
                    <h2 class="font-bold text-base leading-10 text-blue">
                      Kratos Gas & Power Ohio
                    </h2>
                    <h2 class="font-bold text-base leading-10 text-blue">
                      8044 Montgomery Road, Ste 700
                    </h2>
                    <h2 class="font-bold text-base leading-10 text-blue">Cincinnati, OH 45236</h2>
                  </li>

                  <li class="mt-12">
                    <a
                      href="mailto:Hello@kratosgp.com"
                      class="text-base text-gray-500 hover:text-gray-900"
                    >
                      hello@kratosgp.com
                    </a>
                  </li>
                  <li class="mt-4">
                    <a href="tel:800-296-2203" class="text-base text-gray-500 hover:text-gray-900">
                      (800) 296 - 2203
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="hidden md:block mx-auto md:grid-cols-1 md:gap-8">
              <div>
                <h4 class="text-sm leading-5 font-semibold tracking-wider text-gray-400 uppercase">
                  Company
                </h4>
                <ul class="mt-4">
                  <li>
                    <a
                      href="http://georgia.kratosgp.com/"
                      target="_blank"
                      class="font-bold text-base leading-6 text-gray-500 hover:text-gray-900"
                    >
                      Georgia
                    </a>
                  </li>
                  <li class="mt-4">
                    <a
                      href="https://michigan.kratosgp.com/"
                      target="_blank"
                      class="font-bold text-base leading-6 text-gray-500 hover:text-gray-900"
                    >
                      Michigan
                    </a>
                  </li>
                  <li class="mt-4">
                    <a href="/about/" class="text-base leading-6 text-gray-500 hover:text-gray-900">
                      About
                    </a>
                  </li>
                  <li class="mt-4">
                    <a
                      href="/support/"
                      class="text-base leading-6 text-gray-500 hover:text-gray-900"
                    >
                      Support
                    </a>
                  </li>
                  <li class="mt-4">
                    <a href="/terms/" class="text-base leading-6 text-gray-500 hover:text-gray-900">
                      Terms
                    </a>
                  </li>
                  <li class="mt-4">
                    <a
                      href="/certificates-labels/"
                      class="text-base leading-6 text-gray-500 hover:text-gray-900"
                    >
                      Green-E
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="mt-4">
            <img
              class="mx-auto w-2/3"
              src={require('../../svg/BBB_logo_footer.png')}
              alt="BBB logo"
            ></img>
            <img
              class="mt-10 mx-auto w-2/3"
              src={require('../../svg/Green-e-Climate-Certified.png')}
              alt="Greene"
            ></img>
          </div>
        </div>
      </div>
      <div class="w-full">
        <div class="mt-8 py-8 bg-blue px-4 md:px-0 border-t flex  justify-around">
          <div class="ml-6 flex order-1 md:order-2">
            <a
              href="https://www.facebook.com/KratosGasOH/"
              target="_blank"
              class="text-white hover:text-gray-500"
            >
              <span class="sr-only">Facebook</span>
              <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  fill-rule="evenodd"
                  d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 15.491 22 12z"
                  clip-rule="evenodd"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/KratosGasOH/"
              target="_blank"
              class="ml-6 text-white hover:text-gray-500"
            >
              <span class="sr-only">Instagram</span>
              <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  fill-rule="evenodd"
                  d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                  clip-rule="evenodd"
                />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/kratosgp/"
              target="_blank"
              class="ml-6 text-white hover:text-gray-500"
            >
              <span class="sr-only">LinkedIn</span>
              <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  fill-rule="evenodd"
                  d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2 16h-2v-6h2v6zm-1-6.891c-.607 0-1.1-.496-1.1-1.109 0-.614.492-1.109 1.1-1.109s1.1.497 1.1 1.109c0 .613-.493 1.109-1.1 1.109zm8 6.891h-1.998v-2.861c0-1.881-2.002-1.722-2.002 0v2.861h-2v-6h2v1.093c.872-1.616 4-1.736 4 1.548v3.359z"
                  clip-rule="evenodd"
                />
              </svg>
            </a>
          </div>
          <p class=" md:pl-0 text-xs md:text-base leading-6 text-white md:mt-0 md:order-1">
            &copy; {new Date().getFullYear()} Kratos Gas & Power, Inc. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
